import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=40bcdfd3&scoped=true&"
import script from "./AddItem.vue?vue&type=script&lang=js&"
export * from "./AddItem.vue?vue&type=script&lang=js&"
import style0 from "./AddItem.vue?vue&type=style&index=0&id=40bcdfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcdfd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VDivider,VForm,VIcon,VImg,VLayout,VSpacer,VTextField,VTextarea})
